import type { ProductInformationViewModel, RevieveVirtualTryOnViewModel } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const RevieveVTOQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
    variants?: ProductInformationViewModel['variants'];
    vtoConfig?: RevieveVirtualTryOnViewModel;
}>({
    isOpen: false
});

export default function useRevieveVTOQuickView() {
    return useMediatorState(RevieveVTOQuickViewAtom);
}
